import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  DxAccordionModule,
  DxButtonGroupModule,
  DxButtonModule,
  DxCheckBoxModule,
  DxColorBoxModule,
  DxDataGridModule,
  DxDateBoxModule,
  DxDrawerModule,
  DxDropDownButtonModule,
  DxFileUploaderModule,
  DxFilterBuilderModule,
  DxFormModule,
  DxHtmlEditorModule,
  DxListModule,
  DxNumberBoxModule,
  DxPopupModule,
  DxProgressBarModule,
  DxSchedulerModule,
  DxScrollViewModule,
  DxSelectBoxModule,
  DxSortableModule,
  DxSwitchModule,
  DxTabsModule,
  DxTagBoxModule,
  DxTextAreaModule,
  DxTextBoxModule,
  DxToolbarModule,
  DxTreeListModule,
} from 'devextreme-angular';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AgentsSelectionComponent } from './selections/agents-selection/agents-selection.component';
import { LayoutsModule } from '../layouts/layouts.module';
import { ToastrModule } from 'ngx-toastr';
import { SummarySelectionComponent } from './selections/summary-selection/summary-selection.component';
import { FormsModule } from '@angular/forms';
import { HomeComponent } from './home/home.component';
import { MyCalendarComponent } from './home/my-calendar/my-calendar.component';
import { ProfileComponent } from './profile/profile.component';
import { GeneralSettingsComponent } from './profile/general-settings/general-settings.component';
import { SecuritySettingsComponent } from './profile/security-settings/security-settings.component';
import { ProfileTabComponent } from './profile/general-settings/profile-tab/profile-tab.component';
import { EmailTabComponent } from './profile/general-settings/email-tab/email-tab.component';
import { CalendarTabComponent } from './profile/general-settings/calendar-tab/calendar-tab.component';
import { AgCrmCommonModule } from './common/ag-crm-common.module';

@NgModule({
  declarations: [
    AgentsSelectionComponent,
    SummarySelectionComponent,
    HomeComponent,
    MyCalendarComponent,
    ProfileComponent,
    GeneralSettingsComponent,
    SecuritySettingsComponent,
    ProfileTabComponent,
    EmailTabComponent,
    CalendarTabComponent,
  ],
  imports: [
    CommonModule,
    AgCrmCommonModule,
    LayoutsModule,
    FormsModule,
    ToastrModule.forRoot(),

    BrowserAnimationsModule,
    DxDataGridModule,
    DxTextAreaModule,
    DxTextBoxModule,
    DxTabsModule,
    DxButtonModule,
    DxNumberBoxModule,
    DxSelectBoxModule,
    DxDropDownButtonModule,
    DxAccordionModule,
    DxScrollViewModule,
    DxToolbarModule,
    DxFormModule,
    DxPopupModule,
    DxFilterBuilderModule,
    DxListModule,
    DxButtonGroupModule,
    DxHtmlEditorModule,
    DxSwitchModule,
    DxSchedulerModule,
    DxTagBoxModule,
    DxColorBoxModule,
    DxSortableModule,
    DxTreeListModule,
    DxDrawerModule,
    DxDateBoxModule,
    DxCheckBoxModule,
    DxFileUploaderModule,
    DxProgressBarModule,
  ],
})
export class AgCrmModule {}
